import { render } from "./Convenios.vue?vue&type=template&id=0b531245&scoped=true&lang=html"
import script from "./Convenios.vue?vue&type=script&lang=js"
export * from "./Convenios.vue?vue&type=script&lang=js"

import "./Convenios.vue?vue&type=style&index=0&id=0b531245&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b531245"]])

export default __exports__